<template>
  <!-- 根节点保留 advancedSearch-top：有其他页面的 scoped 样式打在这个类上
       （advancedSearch.vue / SearchDetails.vue 都写了 .advancedSearch-top{height:40px}）。
       额外挂一个 topbarShell 钩子类，用来把高度优先级抬上去，见下方样式注释。 -->
  <div class="advancedSearch-top topbarShell">
    <div class="topbar">
      <!-- 返回上一级：描边胶囊 + 箭头图标 -->
      <button type="button" class="topbar__back" @click="getBackClick">
        <i class="el-icon-arrow-left"></i>
        <span>返回上一级</span>
      </button>

      <!-- 用户头像 + 下拉菜单。
           trigger 保持 hover：原始产物里 el-dropdown 没有 trigger 属性（Element 默认即 hover），
           用户也描述成「鼠标放上去出来的四个模块」。本次只做视觉，交互行为不动。 -->
      <el-dropdown
        class="topbar__user"
        trigger="hover"
        placement="bottom-end"
        popper-class="pg-user-menu"
      >
        <span class="topbar__user-trigger">
          <span class="topbar__avatar">
            <img src="../../image/geren/默认头像 (1).png" alt="头像" />
          </span>
          <i class="el-icon-arrow-down topbar__caret"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="gerenClick">
            <i class="el-icon-user"></i>个人中心
          </el-dropdown-item>
          <el-dropdown-item @click.native="gerenSet">
            <i class="el-icon-edit-outline"></i>名称设置
          </el-dropdown-item>
          <el-dropdown-item @click.native="passwordClick">
            <i class="el-icon-lock"></i>修改密码
          </el-dropdown-item>
          <!-- 未登录时写「退出登录」没有意义（点了会调退出接口，接口 500 被拦截器
               静默吞掉，用户看到的是"点了没反应"），直接换成「去登录」 -->
          <el-dropdown-item
            divided
            :class="{ 'is-danger': isLogin }"
            @click.native="quitClick"
          >
            <i
              :class="isLogin ? 'el-icon-switch-button' : 'el-icon-user-solid'"
            ></i>{{ isLogin ? "退出登录" : "去登录" }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog
      title="修改个人昵称"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      center
      custom-class="pg-nick-dialog"
    >
      <div class="nichengSty">
        <span>修改昵称:</span>
        <input type="text" v-model="names" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleList">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { tokenLogin } from "@/api/home";
import { personageName, personageData } from "@/api/personalCenter";
export default {
  name: "quitVue",
  data() {
    return {
      dialogVisible: false,
      names: "",
      // 登录态：组件创建时读一次。页面切换会重建组件，所以登录后能拿到最新值。
      isLogin: !!localStorage.getItem("token"),
    };
  },
  mounted() {},
  methods: {
    //getBackClick  返回上一级
    getBackClick(){
      this.$router.go(-1);
    },
    /** 未登录时的统一出口：去登录页，并带上 redirect，
        登录成功后自动回到当前页（见 store/index.js） */
    goLogin() {
      this.$router.push({
        path: "/logIn",
        query: { redirect: this.$route.fullPath },
      });
    },
    //跳转到密码修改页面
    passwordClick() {
      // /passwordSet 是二级页面，路由守卫本来就会拦；这里提前拦一次，
      // 可以把当前地址带进 redirect，登录后直接回原页面。
      if (!this.isLogin) {
        this.goLogin();
        return;
      }
      this.$router.push("/passwordSet");
    },
    dialogVisibleList() {
      personageName({ nickname: this.names }).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.dialogVisible = false;
          personageData({}).then((res) => {
            console.log(res, "ww8");
            localStorage.setItem("name", this.getAesString(res.data));
          });
          let ct = setTimeout(() => {
            location.reload();
            clearTimeout(ct);
          }, 1000);
        } else {
          this.$message({
            message: "修改失败",
            type: "warning",
          });
          this.dialogVisible = false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    //个人基本设置
    gerenSet() {
      // 未登录弹这个框纯属误导：确定后调 personageName 必然失败，
      // 框会静默关掉，用户以为改成功了。直接送登录页。
      if (!this.isLogin) {
        this.goLogin();
        return;
      }
      this.dialogVisible = true;
    },
    //跳转到个人中心
    gerenClick() {
      if (this.$route.path == "/personalCenter") {
        return;
      } else {
        this.$router.push("/personalCenter");
      }
    },
    quitClick() {
      // 未登录：这里显示的是「去登录」，直接送登录页。
      // 若照常弹「是否退出登录」，确认后会调 tokenLogin → 未登录必然 500，
      // 而 http.js 现在在一级页面上是静默处理，用户看到的就是点了没反应。
      if (!this.isLogin) {
        this.goLogin();
        return;
      }
      this.$confirm("此操作会退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(4154646);
          tokenLogin({}).then((res) => {
            console.log(res, "wwwwww");
            if (res.code == 0) {
              localStorage.removeItem("token");
              localStorage.removeItem("name");
              localStorage.removeItem("dataList");
              this.$message({
                type: "success",
                message: "退出成功!",
              });
              this.$router.push("/");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* ============================================================
   全站二级页顶部栏（18 个页面共用）
   原来：返回按钮写死 margin-left:100px、头像写死 margin-right:50px，
   两者都跟页面内容（1280px 居中卡片）对不上，看着"飘"。
   现在：整条顶栏用与内容卡相同的左右边距（同一套 px→rem 换算），
   返回按钮贴内容左边缘、头像贴内容右边缘，视觉上与卡片成为一体。
   ============================================================ */
$pg-primary: #4834d4;
$pg-primary-lt: #6c5ce7;

.advancedSearch-top {
  width: 100%;
  box-sizing: border-box;
  /* 与内容卡片左右对齐。必须写 calc((100% - 1280px)/2)：
     本项目 px 会被 postcss 按 rem 换算（rootValue≈19.2），
     用同一个表达式才能自动跟随换算，写死 vw / margin 都会差出几十像素。 */
  padding: 0 calc((100% - 1280px) / 2);
}

/* ------------------------------------------------------------------
   高度必须写成「两个类」而不是 .advancedSearch-top 单类 —— 这是个坑：

   子组件的根元素会同时带上「自己的 scoped id」和「父页面的 scoped id」，
   所以父页面里写的 .advancedSearch-top[data-v-父] 也命中这个根元素。

   advancedSearch.vue / SearchDetails.vue 都写了
       .advancedSearch-top { height: 40px; background: #fff; }
   它和本文件里的 .advancedSearch-top[data-v-子] 优先级完全相同（都是 0,2,0），
   于是由「CSS 源码顺序」决定胜负 —— 实测父页面赢，顶栏被压到 41.7px，
   而内部头像触发器有 46px 高，直接**上下越界溢出**（实测 back 的 top=-3）。

   写成 .advancedSearch-top.topbarShell 就是 (0,3,0)，稳定高过父页面的 (0,2,0)，
   不再依赖源码顺序。同时给 min-height 兜底。
   （那两页的规则本来就是给旧顶栏写的，其中的 .advancedSearch-to-del 已经不存在，
     属于半失效的死样式，所以这里覆盖掉它是安全的。）
   ------------------------------------------------------------------ */
.advancedSearch-top.topbarShell {
  height: 56px;
  min-height: 56px;
}

.topbar {
  height: 100%;
  min-height: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* ---------- 返回上一级 ---------- */
.topbar__back {
  display: inline-flex;
  align-items: center;
  height: 34px;
  padding: 0 16px 0 12px;
  border: 1px solid #e2e5f0;
  border-radius: 100px;
  background: #ffffff;
  color: #6b7185;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  line-height: 1;
  cursor: pointer;
  transition: color 0.22s ease, border-color 0.22s ease,
    background 0.22s ease, transform 0.22s ease;

  i {
    font-size: 13px;
    margin-right: 6px;
  }

  &:hover {
    color: $pg-primary;
    border-color: rgba(72, 52, 212, 0.45);
    background: #f6f4ff;
    /* 轻微左移，动作语言上暗示"退回去" */
    transform: translateX(-2px);
  }
  &:active {
    transform: translateX(0);
  }
}

/* ---------- 头像 + 下拉 ---------- */
.topbar__user {
  cursor: pointer;
}

.topbar__user-trigger {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 10px 0 4px;
  border-radius: 100px;
  transition: background 0.22s ease;

  &:hover {
    background: rgba(72, 52, 212, 0.08);
  }
}

.topbar__avatar {
  position: relative;
  width: 36px;
  height: 36px;
  flex-shrink: 0;

  img {
    position: relative;
    z-index: 1;
    display: block;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #f2f3fb;
    object-fit: cover;
  }

  /* 渐变描边环：与「个人中心」页头像是同一套视觉语言。
     注意不能用 z-index:-1，否则会被父级背景盖住。 */
  &::after {
    content: "";
    position: absolute;
    inset: -2px;
    border-radius: 50%;
    background: linear-gradient(135deg, $pg-primary, $pg-primary-lt 55%, #f4c486);
    opacity: 0.9;
  }
}

.topbar__caret {
  margin-left: 7px;
  font-size: 12px;
  color: #9aa0b4;
}

/* ---------- 昵称弹窗 ---------- */
.nichengSty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  span {
    font-size: 15px;
    color: #6b7185;
    flex-shrink: 0;
  }

  input {
    width: 240px;
    height: 40px;
    padding: 0 14px;
    box-sizing: border-box;
    border: 1px solid #e2e5f0;
    border-radius: 10px;
    font-size: 14px;
    font-family: inherit;
    color: #1f2233;
    outline: none;
    transition: border-color 0.22s ease, box-shadow 0.22s ease;

    &:focus {
      border-color: $pg-primary;
      box-shadow: 0 0 0 3px rgba(72, 52, 212, 0.12);
    }
  }
}

::v-deep .el-dialog__body {
  display: flex;
  justify-content: center;
}
</style>

<!-- 下拉菜单与弹窗都挂载到 body 上，scoped 选不到，单独放非 scoped 块 -->
<style lang="scss">
.pg-user-menu.el-dropdown-menu {
  padding: 6px !important;
  min-width: 152px;
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 12px 32px rgba(31, 34, 51, 0.14) !important;

  .el-dropdown-menu__item {
    display: flex;
    align-items: center;
    height: 38px;
    padding: 0 12px;
    border-radius: 8px;
    font-size: 14px;
    color: #1f2233;
    line-height: 1;

    i {
      margin-right: 9px;
      font-size: 15px;
      color: #9aa0b4;
      transition: color 0.2s ease;
    }

    &:not(.is-disabled):hover,
    &:focus {
      background: #f2f3fb;
      color: #4834d4;
      i {
        color: #4834d4;
      }
    }
  }

  /* 「退出登录」前的分隔：Element 自带的 :before 线太贴边，
     关掉它改用 border-top，并把危险项标红 */
  .el-dropdown-menu__item--divided {
    margin-top: 6px;
    border-top: 1px solid #eef0f6;

    &:before {
      display: none;
    }
  }

  .is-danger:not(.is-disabled):hover,
  .is-danger:focus {
    background: #fff1f0;
    color: #e64545;
    i {
      color: #e64545;
    }
  }
}

.pg-nick-dialog {
  border-radius: 16px;
  overflow: hidden;

  .el-dialog__header {
    padding: 20px 22px 14px;
    border-bottom: 1px solid #eef0f6;
  }
  .el-dialog__title {
    font-size: 17px;
    font-weight: 700;
    color: #1f2233;
  }
  .el-dialog__body {
    padding: 24px 22px;
  }
  .el-dialog__footer {
    padding: 0 22px 20px;
  }
}
</style>
